export const SET_NOTIFICATION = "SET_NOTIFICATION";
export const CLEAR_NOTIFICATION = "CLEAR_NOTIFICATION";
export const SHOW_NOTIFICATION_DETAILS = "SHOW_NOTIFICATION_DETAILS";

export const ERROR_NOTIFICATION = "ERROR_NOTIFICATION";
export const WARNING_NOTIFICATION = "WARNING_NOTIFICATION";
export const SUCCESS_NOTIFICATION = "SUCCESS_NOTIFICATION";

export const setErrorNotification = (error, details) => ({
  type: SET_NOTIFICATION,
  notificationType: ERROR_NOTIFICATION,
  message: error.message,
  details
});

export const setWarningNotification = (message, details) => ({
  type: SET_NOTIFICATION,
  notificationType: WARNING_NOTIFICATION,
  message,
  details
});

export const setSuccessNotification = (message, details) => ({
  type: SET_NOTIFICATION,
  notificationType: SUCCESS_NOTIFICATION,
  message,
  details
});

export const clearNotification = () => ({
  type: CLEAR_NOTIFICATION
});

export const showNotificationDetails = () => ({
  type: SHOW_NOTIFICATION_DETAILS
});



// WEBPACK FOOTER //
// ./src/actions/notifications.js